import { USER_ROLES } from "../components/UserProvider";  

export function normalizeAttendee(attendee) {
  return {
    ...attendee,
    ProfileID: attendee.ProfileID,
    NameOnBadge:
      attendee.NameOnBadge || attendee.FirstName + " " + attendee.LastName,
    isHost: attendee.isTeamMember,
    Role: attendee.isTeamMember ? USER_ROLES.HOST: attendee.Role, 
    PrimaryPhotoLocation: attendee.Profile.ProfilePhotoFullPath,
    Profile: {
      FirstName: attendee.FirstName,
      LastName: attendee.LastName,
      ...attendee.Profile,
    },
    CompanyProfile: {
      CompanyName: attendee.Company,
      ...attendee.CompanyProfile,
    },
  };
}
